<template>
  <div>
    <loading-block v-if="vg_loading"></loading-block>
    <v-card v-else elevation="0">
      <v-card-actions>
        <v-spacer />
        <v-btn elevation="0" color="primary" @click="vm_multipleQrDialog(true)"
          >Download QR Code for tables</v-btn
        >
      </v-card-actions>

      <!-- :page.sync="page"
        :footer-props="{
          'items-per-page-options': itemsPerPageProps
        }"
        :items-per-page.sync="itemsPerPage"
        :server-items-length="vg_totalItems" -->
      <v-data-table
        class="px-5 py-3tabulardata"
        :headers="headers"
        :items="vg_items"
        :items-per-page="5"
      >
        <template v-slot:item.is_vacant="{ item }">
          <v-simple-checkbox
            :value="item.is_vacant"
            disabled
          ></v-simple-checkbox>
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on:click="openQrDialog(item)"
                v-on="on"
                fab
                small
                dark
                color="primary"
                class="mr-2"
                depressed
              >
                <v-icon dark>fa-qrcode</v-icon>
              </v-btn>
            </template>
            <span>QR code</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on:click.prevent="editItem(item)"
                v-on="on"
                fab
                small
                dark
                color="primary"
                class="mr-2"
                depressed
              >
                <v-icon dark>edit</v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on:click.prevent="deleteItem(item)"
                v-on="on"
                fab
                small
                dark
                color="primary"
                depressed
              >
                <v-icon dark>delete</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <p class="mb-0">No data.</p>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
export default {
  components: {
    LoadingBlock
  },
  data() {
    return {
      headers: [
        { text: 'Name', value: 'label', sortable: true, width: 200 },
        { text: 'Is Vacant', value: 'is_vacant', sortable: false, width: 200 },
        { text: 'Slug', value: 'slug', sortable: false, width: 200 },
        { text: 'Number', value: 'table_number', sortable: false, width: 200 },
        { text: 'Actions', value: 'action', sortable: false, width: 200 }
      ],
      listItem: [],
      itemsPerPage: 5,
      itemsPerPageProps: [5, 10, 20, 30, 40, 50],
      page: 1
    }
  },
  computed: {
    ...mapGetters({
      vg_items: 'table/getRows',
      vg_itemsPerPage: 'table/getLimit',
      vg_totalItems: 'table/getTotalItems',
      vg_loading: 'table/getLoadingStatus',
      vg_page: 'table/getCurrentPage',
      vg_selectedLocation: 'auth/selectedLocation',
    }),
    // page: {
    //   get() {
    //     return this.vg_page
    //   },
    //   set(val) {
    //     this.vm_setPage(val)
    //     console.log(val)
    //     this.va_fetchTables({
    //       page: val,
    //       limit: this.itemsPerPage
    //     })
    //   }
    // }
  },
  watch: {
    // vg_selectedLocation(val) {
    //   this.va_fetchTables()
    // }
    // page(val) {
    //   console.log(this.page)
    //   console.log(val)
    //   console.log('arrow page changed')
    //   this.va_fetchTables({
    //     page: val,
    //     limit: this.itemsPerPage
    //   })
    // },
    // itemsPerPage(val) {
    //   console.log('drop page changed')
    //   this.vm_setLimit(val)
    //   this.va_fetchTables({
    //     page: this.page,
    //     limit: val
    //   })
    // }
  },
  created() {
    this.va_fetchTables()
  },
  methods: {
    /**
     * Function accept object which has an id, return confirm then delete the category
     */
    deleteItem(obj) {
      document.activeElement.blur()
      const self = this
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        html: `You are about to delete ${obj.label}.`,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        buttonsStyling: false,
        customClass: {
          container: 'custom-swal'
        }
      }).then(async function(result) {
        if (result.value) {
          self.spinner(true)
          let res = await self.va_deleteTable(obj.id)
          self.spinner(false)
          if (res.status === 200) {
            self.$swal(
              'Deleted!',
              `${obj.label} successfully deleted.`,
              'success'
            )
          } else {
            self.$swal('Failed!', 'Please try again later.', 'error')
          }
        }
      })
    },

    /**
     * Edit popup
     */
    editItem(obj) {
      this.vm_setSelected(obj)
      this.vm_edit(true)
    },
    openQrDialog(obj) {
      this.vm_setSelected(obj)
      this.vm_setQrDialog(true)
    },
    ...mapActions({
      va_deleteTable: 'table/deleteTable',
      va_fetchTables: 'table/fetchAll'
    }),
    ...mapMutations({
      vm_setSelected: 'table/SET_SELECTED',
      vm_edit: 'table/SET_DIALOG_EDIT',
      vm_setPage: 'table/SET_PAGE',
      vm_setLimit: 'table/SET_LIMIT',
      vm_setQrDialog: 'table/SET_DIALOG_QRCODE',
      vm_multipleQrDialog: 'table/SET_DIALOG_MULTIPLE_QR_CREATE'
    })
  }
}
</script>
